export enum BaseChartColors {
  PitchViolet = "#4a148c",
  Blue = "#039be5",
  Purple = "#6a1b9a",
  Pink = "#d81b60",
  Green = "#7cb342",
  Orange = "#e65100",
  Indigo = "#3949ab",
}

export enum BaseFontColors {
  TextDark = "#3a3a3a",
  TextMedium = "#757575",
  TextBlack = "#090909",
}

export const BarChartColors = [
  "#ffb74d",
  "#81d4fa",
  "#2196f3",
  "#673ab7",
  "#66bb6a",
  "#f06292",
  "#b2dfdb",
  "#7e57c2",
  "#fdd835",
  "#d4e157",
];

export const LineChartColors = [
  "#90caf9",
  "#2196f3",
  "#0d47a1",
  "#ffcc80",
  "#ff9800",
  "#e65100",
  "#e6ee9c",
  "#cddc39",
  "#827717",
  "#e0e0e0",
];

export const ChartWrapperBorderColor = "#edeff1";
